import _routes from './routes';

export const routes = _routes;

export default {};



// WEBPACK FOOTER //
// ./containers/Group/ProgressTest/ProgressTestDayView/index.js